import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, HelpCircle } from 'lucide-react';
const faqs = [{
  q: '¿Necesito experiencia previa en manifestación?',
  a: 'Para nada. Este libro fue escrito con amor para cualquier persona, sin importar desde dónde parte. La Abu te lleva de la mano desde el principio, con un lenguaje cálido, sencillo y directo. Si es tu primer acercamiento a estos temas, es el lugar perfecto para empezar.'
}, {
  q: '¿Cuánto tiempo tardaré en ver resultados?',
  a: 'Cada persona es única y los tiempos varían. Lo que sí es seguro: las herramientas funcionan desde el primer día que las aplicas con intención. Algunas personas sienten cambios internos casi de inmediato. Para otras, la transformación se vuelve visible en semanas. Lo que marca la diferencia es la constancia.'
}, {
  q: '¿El pago es seguro?',
  a: 'Completamente. El proceso de pago se realiza a través de Hotmart, una de las plataformas más grandes y seguras del mundo para productos digitales. Tus datos están protegidos en todo momento.'
}, {
  q: '¿Cómo recibo el libro y los bonos?',
  a: 'Inmediatamente después de tu compra recibirás un correo con todos los enlaces de descarga. El libro y los 6 bonos están en formato PDF, compatibles con cualquier dispositivo — computadora, tablet o celular.'
}, {
  q: '¿Y si siento que no es para mí?',
  a: 'Tienes 7 días de garantía sin condiciones. Si el contenido no resuena contigo, solicitas el reembolso y listo. Sin preguntas, sin complicaciones.'
}, {
  q: '¿El Método del Jardín Subconsciente™ es difícil de aplicar?',
  a: 'Al contrario. Fue diseñado para ser amoroso, intuitivo y fácil de seguir desde el primer día. No necesitas horas al día ni conocimientos previos. Con minutos de práctica consistente comenzarás a notar cómo tu mente — y tu realidad — empiezan a moverse en una dirección diferente.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 px-4 bg-brand-bg" data-id="element-93">
      <div className="max-w-3xl mx-auto" data-id="element-94">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-95">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-brand-plum/10 rounded-full mb-6" data-id="element-96">
            <HelpCircle className="w-8 h-8 text-brand-plum" data-id="element-97" />
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-brand-plum" data-id="element-98">
            Preguntas Frecuentes
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-99">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white rounded-2xl shadow-sm border border-brand-rose/10 overflow-hidden" data-id="element-100">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" aria-expanded={openIndex === index} data-id="element-101">
                <span className="font-bold text-brand-plum text-lg pr-8 flex items-start gap-3" data-id="element-102">
                  <span className="text-brand-rose" data-id="element-103">❓</span>
                  {faq.q}
                </span>
                <motion.div animate={{
              rotate: openIndex === index ? 180 : 0
            }} transition={{
              duration: 0.3
            }} data-id="element-104">
                  <ChevronDown className="w-6 h-6 text-brand-gold shrink-0" data-id="element-105" />
                </motion.div>
              </button>

              <AnimatePresence data-id="element-106">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-107">
                    <div className="px-6 pb-6 pt-2 text-brand-textLight leading-relaxed border-t border-brand-bgAlt ml-10" data-id="element-108">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}